// TagInput — free-text multi-tag entry. Type a value then Enter (or blur) to
// add a chip; click a chip's ✕ to remove. Used for open-ended lists where a
// fixed picker would be wrong — e.g. BERRY reject defect reasons, which vary by
// site and aren't the citrus defect set. Optional `suggestions` back a native
// datalist for autocomplete without constraining entry. Case-insensitive
// de-dupe; the first-entered casing wins.

import { useState } from 'react'

export default function TagInput({
  value, onChange, placeholder, suggestions = [], id,
}: {
  value:        string[]
  onChange:     (tags: string[]) => void
  placeholder?: string
  suggestions?: string[]
  id?:          string
}) {
  const [draft, setDraft] = useState('')

  function add(raw: string) {
    const t = raw.trim()
    if (t && !value.some(x => x.toLowerCase() === t.toLowerCase())) onChange([...value, t])
    setDraft('')
  }

  const listId = id ? `${id}-list` : undefined

  return (
    <div>
      {value.length > 0 && (
        <div className="flex flex-wrap gap-1.5 mb-1.5">
          {value.map((t, i) => (
            <span key={`${t}-${i}`}
              className="inline-flex items-center gap-1 rounded-full surface-raised text-fg-secondary px-2.5 py-1 text-[11px] font-medium">
              {t}
              <button type="button" onClick={() => onChange(value.filter((_, j) => j !== i))}
                aria-label={`Remove ${t}`} className="text-fg-muted hover:text-red-400 leading-none">✕</button>
            </span>
          ))}
        </div>
      )}
      <input
        id={id}
        type="text"
        className="field"
        aria-label={placeholder ?? 'Add a tag'}
        placeholder={placeholder}
        value={draft}
        list={listId}
        onChange={e => setDraft(e.target.value)}
        onKeyDown={e => { if (e.key === 'Enter') { e.preventDefault(); add(draft) } }}
        onBlur={() => add(draft)}
      />
      {suggestions.length > 0 && (
        <datalist id={listId}>
          {suggestions.map(s => <option key={s} value={s} />)}
        </datalist>
      )}
    </div>
  )
}
